import { useState } from 'react';
import HelpTooltip from './HelpTooltip';
import { Check, Copy } from 'lucide-react';

export default function FixSnippets({ fix_llms, fix_schema }: { fix_llms?: string | null, fix_schema?: string | null }) {
    const [copied, setCopied] = useState<string | null>(null);

    const copyToClipboard = (text: string, key: string) => {
        if (navigator.clipboard) {
            navigator.clipboard.writeText(text).then(() => {
                setCopied(key);
                setTimeout(() => setCopied(null), 2000);
            });
        }
    };

    return (
        <div className="grid md:grid-cols-2 gap-6">
            {fix_llms && (
                <div className="bg-slate-900 rounded-2xl p-6 text-slate-300 shadow-xl">
                    <div className="flex justify-between items-center mb-4">
                        <h3 className="text-indigo-400 font-bold flex items-center gap-2">
                            📄 Generated llms.txt
                            <HelpTooltip
                                title="AI Sitemap (llms.txt)"
                                description="A standardized file that guides AI crawlers to your most important content, ignoring the fluff."
                                benefit="Usage: Copy this code -> Save as 'llms.txt' -> Upload to your website root."
                            />
                        </h3>
                        <button onClick={() => copyToClipboard(fix_llms, 'llms')} className="hover:text-white p-1 transition-colors">
                            {copied === 'llms' ? <Check size={16} className="text-green-400" /> : <Copy size={16} />}
                        </button>
                    </div>
                    <pre className="font-mono text-xs overflow-x-auto p-4 bg-slate-800 rounded-xl border border-slate-700">{fix_llms}</pre>
                    <p className="text-xs text-slate-500 mt-2 italic">* This is an example based on your content. Please review before use.</p>
                </div>
            )}
            {fix_schema && (
                <div className="bg-slate-900 rounded-2xl p-6 text-slate-300 shadow-xl">
                    <div className="flex justify-between items-center mb-4">
                        <h3 className="text-green-400 font-bold flex items-center gap-2">
                            🛡️ Identity Shield Schema
                            <HelpTooltip
                                title="Identity Shield (JSON-LD)"
                                description="A specific code block that explicitly links your website to your social profiles and knowledge graph entries."
                                benefit="Usage: Copy this code -> Paste into the <head> section of your website's home page."
                            />
                        </h3>
                        <button onClick={() => copyToClipboard(fix_schema, 'schema')} className="hover:text-white p-1 transition-colors">
                            {copied === 'schema' ? <Check size={16} className="text-green-400" /> : <Copy size={16} />}
                        </button>
                    </div>
                    <pre className="font-mono text-xs overflow-x-auto p-4 bg-slate-800 rounded-xl border border-slate-700">{fix_schema}</pre>
                    <p className="text-xs text-slate-500 mt-2 italic">* This is an example based on your content. Please review before use.</p>
                </div>
            )}
        </div>
    );
}
